// Compare only editable routing values, excluding server provisioning metadata.
export function sameRoutingSettings(left = {}, right = {}) {
  const normalized = value => {
    const mode = value?.call_mode || 'direct';
    return mode === 'direct' ? ['direct', '', '', ''] : [
      mode,
      String(value?.motor_room_user_id || ''),
      (value?.motor_room_address || '').trim(),
      (value?.pbx_destination || '').trim(),
    ];
  };
  return JSON.stringify(normalized(left)) === JSON.stringify(normalized(right));
}
